import { ApiService } from '../../../services/api_service';
import { DataService } from '../../../services/data_service';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as Moment from 'moment';
import { processAggregation } from './routinen/processAggregation';
import * as React from 'react';
import { saveInChunks } from './saveInChunks';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';

export interface KennzahlenAggregationProps {
    data: any;
}

export interface KennzahlenAggregationState {
    showSpinner: boolean;
}

export class KennzahlenAggregation extends React.Component<KennzahlenAggregationProps, KennzahlenAggregationState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showSpinner: false
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {
        const button = <WActionButton
            label='Jetzt berechnen'
            insideText='Jetzt berechnen'
            tooltip='Jetzt berechnen'
            key='setup'
            action='setup'
            onAction={() => this.setState({ showSpinner: true }, () => {
                const aggregation = processAggregation(this.props.data, [98, 95, 90], [2, 3, 5]) || [];
                // console.log('AGG: ', aggregation);
                const callback = () => {
                    this.triggerService.fire('admin_reload', IDs.ENT_KENNZAHLEN_WERTE_AGGREGATION);
                    this.saveDatum();
                    alert('Daten wurden erzeugt.');
                    this.setState({ showSpinner: false });
                };
                this.apiService.call(
                    'logKennzahlenAggregation',
                    {
                        data: {
                            items: aggregation.length,
                            keys: Object.keys(aggregation[0] || {}),
                            tids: aggregation.map((item: any) => item.tid)
                        }
                    },
                    (json: string, success: boolean) => {
                        console.log('logKennzahlenAggregation', json, success);
                        saveInChunks(aggregation, this.dataService, IDs.ENT_KENNZAHLEN_WERTE_AGGREGATION,IDs.MOD_ETOOL_ADMIN, callback);
                    },
                    IDs.MOD_ETOOL_ADMIN
                );
            })}
        />;
        const customFormatter = (field: string, value: any) => {
            if (field === 'branchen_gewerke_tid') {
                if (+value === -1) {
                    return <div style={{ color: '#aaa' }}><i>Cluster</i></div>;
                } else if (+value === -2) {
                    return <div style={{ color: '#aaa' }}><i>Handwerk gesamt</i></div>;
                }
            }
            return value;
        };
        return <>
            <WFormsTableWrapper
                key={`${IDs.ENT_KENNZAHLEN_WERTE_AGGREGATION}_${this.state.showSpinner}`}
                entity={IDs.ENT_KENNZAHLEN_WERTE_AGGREGATION}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={['delete']}
                customClass='Custom-ETA'
                formLayout='flowV2'
                externalHeaderElements = {[button]}
                onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_KENNZAHLEN_WERTE_AGGREGATION)}
                onDelDone={() => this.triggerService.fire('admin_reload', IDs.ENT_KENNZAHLEN_WERTE_AGGREGATION)}
                showColumnsHelp
                customFormatter={customFormatter}
            />
            {this.state.showSpinner && <WSpinner />}
        </>;
    }

    saveDatum(): void {
        const entity: string = IDs.ENT_SYSTEMPARAMETER || null;
        const tid: number = ((this.props.data[entity] || [])
            .find((element: any) => (element.parameter || null) === 'kennzahlen_aggregation_datum')).tid || null;
        this.dataService.updateDataSingle(
            entity, tid,
            { wert: Moment().format('DD.MM.YYYY') },
            () => this.triggerService.fire('admin_reload', entity),
            IDs.MOD_ETOOL_ADMIN
        );
    }
}
